<main class="content">
  <h2 class="fw-light" [style]="'margin-top: 40px; margin-bottom: 20px'">
    {{ 'stepSummaryTitle' | i18next }}
  </h2>
  <div *ngIf="car" class="d-flex flex-column gap-2">
    <h5 *ngIf="campaignType === campaignTypeEnum.STANDARD">
      {{ 'requestedCar' | i18next }}
    </h5>
    <h5 *ngIf="campaignType === campaignTypeEnum.RAFFLE">
      {{ 'priorityList' | i18next }}
    </h5>
    <div class="card" *ngIf="campaignType === campaignTypeEnum.RAFFLE">
      <div class="card-column d-flex flex-column">
        <div
          *ngFor="let item of car; let i = index"
          class="item d-flex flex-column gap-1 mb-2"
        >
          <span class="text-black fw-bold"
            >{{ i + 1 }}. {{ item.model }} - {{ item.title }}</span
          >
        </div>
      </div>
    </div>

    <h5 *ngIf="!campaignType" class="fw-bold">
      {{ 'requestedCar' | i18next }}
    </h5>
    <div
      class="card"
      *ngIf="campaignType === campaignTypeEnum.STANDARD || !campaignType"
    >
      <div class="step-summary__img">
        <img
          [style]="'width: 100%'"
          [src]="car.image || '../../../../assets/img/NeutroNaranjaRojo_v2.png'"
          alt="Imagen vehículo"
        />
      </div>
      <div class="d-flex flex-column gap-1 step-summary__data">
        <div
          class="d-flex justify-content-between mb-2 step-summary__content-row-data"
        >
          <div class="d-flex flex-column gap-1">
            <span class="text-black text-uppercase lead fw-bold">{{
              car.model
            }}</span>
          </div>
        </div>
        <div
          class="d-flex justify-content-between step-summary__content-row-data"
        >
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black text-uppercase fw-bold">{{
              'color' | i18next
            }}</span>
            <span class="text-muted">{{
              car.exteriorColorDescription || car.descExtColor
            }}</span>
          </div>
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black text-uppercase fw-bold">{{
              'combustible' | i18next
            }}</span>
            <span class="text-muted">{{
              translateFuelType(car.fuelType)
            }}</span>
          </div>
          <!-- TODO: descomentar cuando lleguen dato de potencia y consumo y quitar los datos de color y combustible de arriba
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black text-uppercase fw-bold">{{
              'power' | i18next
            }}</span>
            <span class="text-muted"
              >{{ car.power ? car.power.hp : '-' }}CV /
              {{ car.power ? car.power.kw : '-' }}KW</span
            >
          </div>
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black text-uppercase fw-bold">{{
              'consumption' | i18next
            }}</span>
            <span class="text-muted">{{ car.consumption | valueData }}</span>
          </div> -->
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black text-uppercase fw-bold">{{
              'estimatedEmissions' | i18next
            }}</span>
            <span class="text-muted">{{ car.emissions }} g/km</span>
          </div>
        </div>
        <hr />
        <div
          class="d-flex justify-content-between mb-2 step-summary__content-row-data"
        >
          <div class="d-flex flex-column w-100 gap-1" *ngIf="car.transmission">
            <span class="text-black fw-bold">{{ 'gearbox' | i18next }}</span>
            <span class="text-muted">{{ car.transmission | valueData }}</span>
          </div>
          <!-- TODO: descomentar cuando lleguen dato de potencia y consumo y quitar los datos de color y combustible de arriba
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold">{{
              'combustible' | i18next
            }}</span>
            <span class="text-muted">{{ car.fuelType }}</span>
          </div>
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold">{{ 'color' | i18next }}</span>
            <span class="text-muted">{{
              car.exteriorColorDescription || car.descExtColor
            }}</span>
          </div> -->
          <div class="d-flex flex-column w-100 gap-1">
            <span class="text-black fw-bold text-uppercase">{{
              'requestPccTMAIMG' | i18next
            }}</span>
            <span class="text-muted">{{ car.tmaimg }}</span>
          </div>
          <div
            class="d-flex flex-column w-100 gap-1"
            *ngIf="car.VIN && requestType !== requestTypeEnum.leasing"
          >
            <span class="text-black fw-bold">{{ 'vinNumber' | i18next }}</span>
            <span class="text-muted">{{ car.VIN | valueData }}</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="substitutionVehicle">
      <h5 class="fw-bold">{{ 'stepReplaceVehicle' | i18next }}</h5>
      <div class="card">
        <div class="step-summary__img">
          <img
            [style]="'width: 100%'"
            [src]="
              substitutionVehicle.image ||
              '../../../../assets/img/NeutroNaranjaRojo_v2.png'
            "
            alt="Imagen vehículo"
          />
        </div>
        <div class="d-flex flex-column gap-1" style="width: 100%">
          <div
            class="d-flex justify-content-between mb-2 step-summary__content-row-data"
          >
            <div class="d-flex flex-column gap-1">
              <span class="text-black text-uppercase lead fw-bold">{{
                substitutionVehicle.model | valueData
              }}</span>
              <span class="text-black text-uppercase text-sm">{{
                substitutionVehicle.plateNumber | valueData
              }}</span>
            </div>
          </div>
          <hr />
          <div
            class="d-flex justify-content-between mb-2 step-summary__content-row-data"
          >
            <div class="d-flex flex-column w-100 gap-1">
              <span class="text-black fw-bold">{{
                'motorization' | i18next
              }}</span>
              <span class="text-muted">{{
                substitutionVehicle.motor | valueData
              }}</span>
            </div>
            <div class="d-flex flex-column w-100 gap-1">
              <span class="text-black fw-bold">{{ 'gearbox' | i18next }}</span>
              <span class="text-muted">{{
                substitutionVehicle.transmission | valueData
              }}</span>
            </div>
            <div class="d-flex flex-column w-100 gap-1">
              <span class="text-black fw-bold">{{
                'combustible' | i18next
              }}</span>
              <span class="text-muted">{{
                substitutionVehicle.fuelType | valueData
              }}</span>
            </div>
            <div class="d-flex flex-column w-100 gap-1">
              <span class="text-black fw-bold">{{ 'color' | i18next }}</span>
              <span class="text-muted">{{
                substitutionVehicle.color | valueData
              }}</span>
            </div>
          </div>
          <div
            class="d-flex justify-content-between mb-2 step-summary__content-row-data"
          >
            <div
              class="d-flex flex-column w-100 gap-1"
              *ngIf="requestType !== requestTypeEnum.leasing"
            >
              <span class="text-black fw-bold">{{
                'vinNumber' | i18next
              }}</span>
              <span class="text-muted">{{
                substitutionVehicle.VIN | valueData
              }}</span>
            </div>
            <div class="d-flex flex-column w-100 gap-1">
              <span class="text-black fw-bold text-uppercase">{{
                'estimatedEmissions' | i18next
              }}</span>
              <span class="text-muted"
                >{{ substitutionVehicle.emissions | valueData }} g/km</span
              >
            </div>
            <div class="d-flex flex-column w-100 gap-1">
              <span class="text-black fw-bold text-uppercase">{{
                'requestPccTMAIMG' | i18next
              }}</span>
              <span class="text-muted">{{
                substitutionVehicle.tmaimg | valueData
              }}</span>
            </div>
            <div class="d-flex flex-column w-100 gap-1" *ngIf="additionalInfo">
              <span class="text-black fw-bold">{{
                'kilometers' | i18next
              }}</span>
              <span class="text-muted"
                >{{ additionalInfo.estimatedKms }} KM</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <h5>{{ 'generalData' | i18next }}</h5>
    <div class="card" [style]="'justify-content: space-between'">
      <div
        *ngIf="additionalInfo && additionalInfo.requestCarType"
        class="d-flex flex-column gap-1"
      >
        <span class="text-black fw-bold">{{ 'category' | i18next }}</span>
        <span class="text-muted">{{
          additionalInfo.requestCarType | i18next
        }}</span>
      </div>
      <div *ngIf="additionalInfo" class="d-flex flex-column gap-1">
        <span class="text-black fw-bold">{{ 'type' | i18next }}</span>
        <span *ngIf="additionalInfo.substitutionVin" class="text-muted">{{
          'subtypeSus' | i18next
        }}</span>
        <span *ngIf="!additionalInfo.substitutionVin" class="text-muted">{{
          'subtypeFirstAssign' | i18next
        }}</span>
      </div>
      <div
        class="d-flex flex-column gap-1"
        *ngIf="requestType !== requestTypeEnum.leasing"
      >
        <span class="text-black fw-bold">{{ 'retribution' | i18next }}</span>
        <span class="text-muted">{{ retributionText | valueData: '-' }}</span>
      </div>
      <div
        *ngIf="(car && car.prices && car.prices.fee) || (car && car.price)"
        class="d-flex flex-column gap-1"
      >
        <span class="text-black fw-bold">{{ 'requestFee' | i18next }}</span>
        <span class="text-muted"
          >{{
            car.prices
              ? (car.prices.fee | numberData)
              : (car.price | numberData)
          }}
          €</span
        >
      </div>
      <div
        class="d-flex flex-column gap-1"
        *ngIf="
          requestType === requestTypeEnum.leasing &&
          car &&
          car.prices &&
          car.prices.leasingRE
        "
      >
        <span class="text-black fw-bold">{{
          'leasingRetribution' | i18next
        }}</span>
        <span class="text-muted"
          >{{ car.prices.leasingRE ? car.prices.leasingRE : '0' }}€</span
        >
      </div>
      <div
        class="d-flex flex-column gap-1"
        *ngIf="requestType === requestTypeEnum.leasing"
      >
        <span class="text-black fw-bold">{{ 'totalFee' | i18next }}</span>
        <span class="text-muted">{{ calculateTotalFee(car) }}</span>
      </div>
      <div
        *ngIf="
          requestType !== requestTypeEnum.leasing &&
          car &&
          car.prices &&
          (car.prices.primaryRE || car.prices.primaryRetribution) &&
          retribution === 'PRIMARY'
        "
        class="d-flex flex-column gap-1"
      >
        <span class="text-black fw-bold">{{
          'retributionPrimary' | i18next
        }}</span>
        <span class="text-muted"
          >{{
            (car.prices.primaryRE
              ? car.prices.primaryRE
              : car.prices.primaryRetribution
            ) | numberData
          }}€</span
        >
      </div>
      <div
        *ngIf="
          requestType !== requestTypeEnum.leasing &&
          car &&
          car.prices &&
          (car.prices.secondaryRE || car.prices.secondRetribution) &&
          retribution === 'SECONDARY'
        "
        class="d-flex flex-column gap-1"
      >
        <span class="text-black fw-bold">{{
          'retributionSecondary' | i18next
        }}</span>
        <span class="text-muted"
          >{{
            car.prices.secondaryRE
              ? car.prices.secondaryRE
              : (car.prices.secondRetribution | numberData)
          }}€</span
        >
      </div>
      <div
        *ngIf="
          requestType !== requestTypeEnum.leasing &&
          car &&
          car.prices &&
          car.prices.primaryEndowmentRE &&
          retribution === 'PRIMARY_ENDOWMENT'
        "
        class="d-flex flex-column gap-1"
      >
        <span class="text-black fw-bold">{{
          'retributionEndowmentPrimary' | i18next
        }}</span>
        <span class="text-muted"
          >{{ car.prices.primaryEndowmentRE | numberData }}€</span
        >
      </div>
      <div
        *ngIf="
          requestType !== requestTypeEnum.leasing &&
          car &&
          car.prices &&
          car.prices.secondaryEndowmentRE &&
          retribution === 'SECONDARY_ENDOWMENT'
        "
        class="d-flex flex-column gap-1"
      >
        <span class="text-black fw-bold">{{
          'retributionEndowmentSecondary' | i18next
        }}</span>
        <span class="text-muted"
          >{{ car.prices.secondaryEndowmentRE | numberData }}€</span
        >
      </div>
    </div>

    <h5 *ngIf="requestType === requestTypeEnum.leasing">
      {{ 'chargedDocuments' | i18next }}
    </h5>
    <div class="card" *ngIf="requestType === requestTypeEnum.leasing">
      <div class="card-column d-flex flex-column">
        <div
          *ngFor="let item of docInfo?.docs; let i = index"
          class="item d-flex flex-column gap-1 mb-2"
        >
          <span class="text-black fw-bold"
            >{{ i + 1 }}. {{ item.documentType | i18next }} -
            {{ item.fileName }}</span
          >
        </div>
      </div>
    </div>

    <h5
      *ngIf="
        (car.optionals && car.optionals.length > 0) ||
        (car.extensions && car.extensions.length > 0) ||
        (car.descriptionOptionalCodes &&
          car.descriptionOptionalCodes.length > 0) ||
        (car.descriptionExtensionsCodes &&
          car.descriptionExtensionsCodes.length > 0)
      "
    >
      {{ 'equipment' | i18next }}
    </h5>
    <div
      *ngIf="
        (car.optionals && car.optionals.length > 0) ||
        (car.extensions && car.extensions.length > 0) ||
        (car.descriptionOptionalCodes &&
          car.descriptionOptionalCodes.length > 0) ||
        (car.descriptionExtensionsCodes &&
          car.descriptionExtensionsCodes.length > 0)
      "
      class="card"
      [style]="'flex-direction: column'"
    >
      <details>
        <summary>
          <span class="text-black">{{ 'details' | i18next }}</span>
        </summary>
        <ul class="my-4" *ngIf="car.optionals">
          <li *ngFor="let optional of car.optionals">
            <span class="text-muted">{{ optional.description }}</span>
          </li>
        </ul>
        <ul class="my-4" *ngIf="car.extensions">
          <li *ngFor="let optional of car.extensions">
            <span class="text-muted">{{ optional.description }}</span>
          </li>
        </ul>
        <ul class="my-4" *ngIf="car.descriptionOptionalCodes">
          <li *ngFor="let optional of car.descriptionOptionalCodes">
            <span class="text-muted">{{ optional }}</span>
          </li>
        </ul>
        <ul class="my-4" *ngIf="car.descriptionExtensionsCodes">
          <li *ngFor="let optional of car.descriptionExtensionsCodes">
            <span class="text-muted">{{ optional }}</span>
          </li>
        </ul>
      </details>
    </div>

    <div *ngIf="requestType !== requestTypeEnum.leasing">
      <h5>{{ 'stepAddInfo' | i18next }}</h5>
      <div
        *ngIf="additionalInfo"
        class="card"
        [style]="
          'flex-direction: column; justify-content: flex-start; align-items: flex-start;; gap: 1rem; margin-bottom: 20px'
        "
      >
        <div class="d-flex gap-3 step-summary__aditional-info-first-container">
          <div class="d-flex flex-column gap-1" style="width: 200px">
            <span class="text-black fw-bold">{{
              'additionalEmail' | i18next
            }}</span>
            <span class="text-muted">{{
              additionalInfo.email | valueData: '-'
            }}</span>
          </div>
          <div class="d-flex flex-column gap-1" style="width: 200px">
            <span class="text-black fw-bold">{{
              'additionalPhone' | i18next
            }}</span>
            <span class="text-muted">{{
              additionalInfo.phone | valueData: '-'
            }}</span>
          </div>
        </div>
        <div class="d-flex flex-column gap-1">
          <span class="text-black fw-bold">{{ 'observations' | i18next }}</span>
          <span class="text-muted">{{
            additionalInfo.comments | valueData: '-'
          }}</span>
        </div>
        <div
          *ngIf="additionalInfo.deliveryLocationChecked"
          class="d-flex flex-column gap-1"
        >
          <span class="text-black fw-bold">{{
            'deliveryLocationText' | i18next
          }}</span>
          <span class="text-muted">{{ 'btnYes' | i18next }}</span>
        </div>
      </div>
    </div>

    <div class="btnContainer">
      <button class="btnContainer__btn" mat-button (click)="response(true)">
        {{ 'buttonConfirm' | i18next | uppercase }}
      </button>
      <button
        class="btnContainer__btn btnContainer__btn__back"
        [style]="
          'background-color: #2c2a29; display: flex; align-items: center; gap: 0.5rem'
        "
        mat-button
        (click)="response(false)"
      >
        <mat-icon class="icon">arrow_back</mat-icon>
        {{ 'btnReturn' | i18next | uppercase }}
      </button>
    </div>
  </div>
</main>
